import { render, staticRenderFns } from "./FooterLeft.vue?vue&type=template&id=6b83f2dc&scoped=true"
import script from "./FooterLeft.vue?vue&type=script&lang=js"
export * from "./FooterLeft.vue?vue&type=script&lang=js"
import style0 from "./FooterLeft.vue?vue&type=style&index=0&id=6b83f2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83f2dc",
  null
  
)

export default component.exports